import { render, staticRenderFns } from "./rotationform.vue?vue&type=template&id=16c8f194&"
import script from "./../../ts/dialog/rotationform.ts?vue&type=script&lang=js&"
export * from "./../../ts/dialog/rotationform.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports